import AddRole from "./components/Admin/Role/AddRole/addRole";
import Signin from "./Auth/Signin";
import SuperAdminDashBoard from "./components/Dashboard/SuperAdminDashBoard";
import NewReq from "./components/Client/NewRequest/NewReq";
import Roles from "./components/Admin/Role/Roles/Roles";
import Clients from "./components/Client/ActiveClients/Clients";
import AddClient from "./components/Client/ActiveClients/AddClient/AddClient";
import SubsCription from "./components/Admin/Subscriptions/SubsCription";
import AddSubs from "./components/Admin/Subscriptions/AddSubscription/AddSubs";
import Menu from "./components/Admin/Menu/Menu";
import AddMenu from "./components/Admin/Menu/AddMenu/AddMenu";
import AssignMenu from "./components/Admin/AssignMenu/AssignMenu";
import Payment from "./components/Payments/Payment";
import Companies from "./components/Admin/Company/Companies/Companies";
import AddCompany from "./components/Admin/Company/AddCompany/addCompany";
import Categories from "./components/Admin/Category/Categories/Categories";
import AddCategory from "./components/Admin/Category/AddCategory/AddCategory";
import Models from "./components/Admin/Model/Models/Models";
import AddModel from "./components/Admin/Model/AddModel/addModel";
import Makes from "./components/Admin/Make/Makes/Makes";
import AddMake from "./components/Admin/Make/AddMake/addMake";
import AddProduct from "./components/Admin/Product/AddProduct/addProduct";
import Products from "./components/Admin/Product/Products/Products";
import FuelTypes from "./components/Admin/FuelType/FuelTypes/FuelTypes";
import AddFuelType from "./components/Admin/FuelType/AddFuelType/addFuelType";
import AddCaseType from "./components/Admin/CaseType/AddCaseType/addCaseType";
import CaseTypes from "./components/Admin/CaseType/CaseTypes/CaseTypes";
import AddProductSubType from "./components/Admin/ProductSubType/AddProductSubType/AddProductSubType";
import ProductSubTypes from "./components/Admin/ProductSubType/ProductSubTypes/ProductSubTypes";

import AddPolicyType from "./components/Admin/PolicyType/AddPolicyType/AddPolicyType";
import PolicyTypes from "./components/Admin/PolicyType/PolicyTypes/PolicyTypes";
import BlogList from "./components/Blog/Blog";
import AddBlogForm from "./components/Blog/AddBlogForm";
// import EditBlogPage from "./components/Blog/EditBlogForm";
import DeleteBlogPage from "./components/Blog/DeleteBlogPage";
import AddNewsForm from "./components/News/AddNewsForm";
import DeleteNewsPage from "./components/News/DeleteNewsPage";
import NewsList from "./components/News/News";
const routes = [
  {
    path: "/",
    children: [
      {
        path: "",
        element: <Signin />,
      },
    ],
  },
  {
    path: "/super-admin",
    children: [
      {
        path: "dashboard",
        element: <SuperAdminDashBoard />,
      },
      {
        path: "client/new-rq",
        element: <NewReq />,
      },
      {
        path: "clients",
        children: [
          {
            path: "",
            element: <Clients />,
          },
          {
            path: "add",
            element: <AddClient />,
          },
          {
            path: "edit",
            element: <AddClient />,
          },
        ],
      },
    ],
  },
  {
    path: "policytype",
    children: [
      {
        path: "",
        element: (

          <PolicyTypes />

        ),
      },
      {
        path: "add",
        element: (

          <AddPolicyType />

        ),
      },
      {
        path: "/policytype/:policyTypeId/edit",
        element: (

          <AddPolicyType />

        ),
      },
    ],
  },
  {
    path: "role",
    children: [
      {
        path: "",
        element: <Roles />,
      },
      {
        path: "add",
        element: <AddRole />,
      },
      {
        path: "/role/:roleId/edit",
        element: <AddRole />,
      },
    ],
  },
  {
    path: "subscription",
    children: [
      {
        path: "",
        element: <SubsCription />,
      },
      {
        path: "add",
        element: <AddSubs />,
      },
      {
        path: "edit",
        element: <AddSubs />,
      },
    ],
  },
  {
    path: "menu",
    children: [
      {
        path: "",
        element: <Menu />,
      },
      {
        path: "add",
        element: <AddMenu />,
      },
      {
        path: "edit",
        element: <AddMenu />,
      },
    ],
  },
  {
    path: "companies",
    children: [
      {
        path: "",
        element: (
          <Companies />
        ),
      },
      {
        path: "add",
        element: (
          <AddCompany />
        ),
      },
      {
        path: "/companies/:companyId/edit",
        element: (

          <AddCompany />

        ),
      },
    ],
  },

  {
    path: "products",
    children: [
      {
        path: "",
        element: (

          <Products />

        ),
      },
      {
        path: "add",
        element: (

          <AddProduct />

        ),
      },
      {
        path: "/products/:productId/edit",
        element: (

          <AddProduct />

        ),
      },
    ],
  },
  {
    path: "companies",
    children: [
      {
        path: "",
        element: (

          <Companies />

        ),
      },
      {
        path: "add",
        element: (

          <AddCompany />

        ),
      },
      {
        path: "/companies/:companyId/edit",
        element: (

          <AddCompany />

        ),
      },
    ],
  },


  {
    path: "categories",
    children: [
      {
        path: "",
        element: (

          <Categories />

        ),
      },
      {
        path: "add",
        element: (

          <AddCategory />

        ),
      },
      {
        path: "/categories/:categoryId/edit",
        element: (

          <AddCategory />

        ),
      },
    ],
  },
  {
    path: "models",
    children: [
      {
        path: "",
        element: (

          <Models />

        ),
      },
      {
        path: "add",
        element: (

          <AddModel />

        ),
      },
      {
        path: "/models/:modelId/edit",
        element: (

          <AddModel />

        ),
      },
    ],
  },
  {
    path: "makes",
    children: [
      {
        path: "",
        element: (

          <Makes />

        ),
      },
      {
        path: "add",
        element: (

          <AddMake />

        ),
      },
      {
        path: "/makes/:makeId/edit",
        element: (

          <AddMake />

        ),
      },
    ],
  },
  {
    path: "subproducts",
    children: [
      {
        path: "",
        element: (

          <ProductSubTypes />

        ),
      },
      {
        path: "add",
        element: (

          <AddProductSubType />

        ),
      },
      {
        path: "/subproducts/:productSubTypeId/edit",
        element: (

          <AddProductSubType />

        ),
      },
      {
        path: "/subproducts/add/:productId",
        element: (

          <AddProductSubType />

        ),
      },
    ],
  },
  {
    path: "casetype",
    children: [
      {
        path: "",
        element: (

          <CaseTypes />

        ),
      },
      {
        path: "add",
        element: (

          <AddCaseType />

        ),
      },
      {
        path: "/casetype/:caseTypeId/edit",
        element: (

          <AddCaseType />

        ),
      },
    ],
  },
  {
    path: "fueltype",
    children: [
      {
        path: "",
        element: (

          <FuelTypes />

        ),
      },
      {
        path: "add",
        element: (

          <AddFuelType />

        ),
      },
      {
        path: "/fueltype/:fuelTypeId/edit",
        element: (

          <AddFuelType />

        ),
      },
    ],
  },

  {
    path: "assign-menu",
    children: [
      {
        path: "",
        element: <AssignMenu />,
      },
    ],
  },
  {
    path: "payments",
    children: [
      {
        path: "",
        element: <Payment />,
      },
    ],
  },
  {
    path: "blogs",
    children: [
      {
        path: "",
        element: < BlogList/>,
      },
      {
        path: "add",
        element: < AddBlogForm/>,
      },
      {
        path: "edit/:id",
        element: <AddBlogForm/>,
      },
      { 
        path: "delete/:id",
         element: <DeleteBlogPage />
      },
    ],
  },
  {
    path: "news",
    children: [
      {
        path: "",
        element: <NewsList />,
      },
      {
        path: "add",
        element: <AddNewsForm />,
      },
      {
        path: "edit/:id",
        element: <AddNewsForm />,
      },
      { 
        path: "delete/:id",
        element: <DeleteNewsPage />,
      },
    ],
},
];
export default routes;
